import React, {Fragment, memo} from 'react'

const FooterRow = memo(({row}) => (
  <li className="footer__list-item">
    {row?.links?.map((link, index) => (
      <Fragment>
        <a href={link?.link}>
          {link?.text}
        </a>
        {(row?.links?.length > 1 && index < row?.links?.length - 1) && ' / '}
      </Fragment>
    ))}
  </li>
))

export default FooterRow
